import { IApplicationState } from '../../../types/redux';

export const selectCurrentRegion = (state: IApplicationState) => state.geo.currentRegion;
